import { Ban, Building2, FileText } from 'lucide-react'
import { useTranslation } from 'react-i18next'

/**
 * Blocked-state UI shown when no organisations and no orphaned invoices exist
 * — the form has nothing to attach a licence to.
 */
export function LicenseCriteriaPrerequisitesBlock(): React.ReactElement {
  const { t } = useTranslation('admin')

  return (
    <div className="rounded-xl border border-stone-200 bg-white p-6 shadow-sm dark:border-stone-700 dark:bg-stone-800">
      <h3 className="mb-4 text-lg font-semibold text-stone-900 dark:text-white">
        {t('licensing.createCriteria')}
      </h3>
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <div className="mb-4 rounded-full bg-amber-100 p-4 dark:bg-amber-900/30">
          <Ban className="h-8 w-8 text-amber-600 dark:text-amber-400" />
        </div>
        <h4 className="mb-2 text-lg font-medium text-stone-900 dark:text-white">
          {t('licensing.prerequisitesRequired')}
        </h4>
        <p className="mb-4 max-w-md text-sm text-stone-600 dark:text-stone-400">
          {t('licensing.prerequisitesIntro')}
        </p>
        <ul className="mb-6 space-y-2 text-left text-sm text-stone-600 dark:text-stone-400">
          <li className="flex items-center gap-2">
            <Building2 className="h-4 w-4 text-stone-400" />
            {t('licensing.prerequisitesOrg')}
          </li>
          <li className="flex items-center gap-2">
            <FileText className="h-4 w-4 text-stone-400" />
            {t('licensing.prerequisitesInvoice')}
          </li>
        </ul>
        <p className="text-xs text-stone-500 dark:text-stone-400">
          {t('licensing.prerequisitesAction')}
        </p>
      </div>
    </div>
  )
}
